<template>
  <div
    v-if="image || featuredVideo"
    class="article-featured-media__wrapper"
    :class="dynamicImageWrapperClasses"
  >
    <a-media
      :image="image"
      :image-aspect-ratio="featuredMediaAspectRatio"
      :image-width="$options.consts.renderImageWidth"
      :video="featuredVideo"
      :video-aspect-ratio="featuredMediaAspectRatio"
      :url="linkToArticle"
      :link-trailing-slash="!isMigrated"
      :viewport-optimization="viewportOptimization"
      :srcset-location="srcsetLocation"
      class="article-featured-media__media"
    />
  </div>
</template>

<script>
import { PROP_TYPES, propValidator } from '@fmpedia/validators'
import { aspectRatios } from 'enums/aspectRatios'
import { hydrateWhenVisible } from '@/utils/helpers/vue-lazy-hydration/LazyHydrate'
import mixins from '@/utils/mixins'
import { IMAGE_SIZE, IMAGE_SIZE_VALUE } from 'enums/images'

export default {
  name: 'ArticleFeaturedMedia',
  mixins: [mixins.urlGenerators],
  components: {
    AMedia: hydrateWhenVisible(() => import('shared/AMedia'), {
      props: [
        'image',
        'image-aspect-ratio',
        'image-width',
        'video',
        'video-aspect-ratio',
        'url',
        'link-trailing-slash',
        'viewport-optimization',
        'srcset-location'
      ]
    })
  },
  props: {
    slug: propValidator([PROP_TYPES.STRING]),
    isMigrated: propValidator([PROP_TYPES.BOOLEAN], false, false),
    category: propValidator([PROP_TYPES.OBJECT], false),
    featuredImage: propValidator([PROP_TYPES.OBJECT], false),
    thumbnailImage: propValidator([PROP_TYPES.OBJECT], false),
    featuredVideo: propValidator([PROP_TYPES.OBJECT], false),
    viewportOptimization: propValidator([PROP_TYPES.BOOLEAN], false, false),
    srcsetLocation: propValidator([PROP_TYPES.STRING], false, null)
  },
  consts: {
    renderImageWidth: IMAGE_SIZE_VALUE[IMAGE_SIZE.WIDTH_775]
  },
  computed: {
    image() {
      return this.thumbnailImage || this.featuredImage
    },
    dynamicImageWrapperClasses() {
      return {
        'article-slot__no-fixed-height': this.isMigrated,
        image: !!this.image
      }
    },
    featuredMediaAspectRatio() {
      if (this.image) return this.featuredImageAspectRatio

      return aspectRatios.articleFeaturedVideo
    },
    featuredImageAspectRatio() {
      if (this.isMigrated) return aspectRatios.noRatio

      return aspectRatios.articleFeaturedImage
    },
    linkToArticle() {
      return this.generateArticlePath({
        categorySlug: this.category.slug,
        slug: this.slug,
        isMigrated: this.isMigrated
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.article-featured-media__wrapper,
.article-featured-media__media {
  border-radius: 6px;
  overflow: hidden;
}
</style>
